<template>
    <div>
        <el-dialog title="审核" :visible.sync="visible" width="30%" center :before-close="close">
            <el-form :model="form">
                <el-form-item label="审核状态">
                    <el-select v-model="form.status" placeholder="请选择">
                        <el-option label="通过" value="NORMAL"></el-option>
                        <el-option label="拒绝" value="REJECT"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="saveCheck">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            form: {
                id: '',
                status: '',
            }
        }
    },
    methods: {
        openDialog(_id) {
            this.form.id = _id;
            this.visible = true;
        },
        saveCheck() {
            var _this = this;
            _this.$common.ajaxRequest({
                url: '/shop/checkShop',
                data: _this.form,
                success: resp => {
                    this.$message.success('审核成功')
                    this.$router.push({name: 'shopList'})
                }
            })
        },
        close() {
            this.form = {};
            this.visible = false;
        }
    }
}
</script>